module.exports = require('./FAB.vue');